import { Apis } from "libs/apis"
import { dispatch } from "store"
import { setModalClosed } from "store/user-slice"
import { PrecookingSetupDTO } from "utils/helpers/models/precookingSetup.dto"

export const usePrecookingSetups = () => {
    const getPrecookingSetups = async (setData: any) => {
        try {
            const res = await Apis.getPrecookingSetups()
            setData(res.data.data)
        } catch (err: any) {
            if (err.response && err.response.status === 404) {
                setData(null)
            } else {
                console.error(err)
            }
        }
    }

    const postPrecookingSetup = async (body: PrecookingSetupDTO) => {
        try {
            const res = await Apis.postPrecookingSetup(body);
            if (res.data.status) {
                dispatch(setModalClosed('Precooking Setup'));
            }
            return res;
        } catch (err) {
            console.error(err);
            throw err;
        }
    }
    return {
        getPrecookingSetups,
        postPrecookingSetup
    }
}
